<div style="display: flex; flex-direction: row; justify-content: space-between; align-items: baseline;">
    @if (mode === 'Update') {
    <h2>Edit organisation @if (organisation.archived) {<span>(Archived)</span>}</h2>
    } @else {
    <h2>Create new organisation</h2>
    }
    <div class="n-last-modifications">
        @if (organisation.lastModifiedOn) {
        Last update: {{ organisation | lastUpdate }}
        }
    </div>
</div>

<form [formGroup]="organisationFG">
    <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel class="n-common-data-panel"
            [style.background-color]="(organisation.archived ? 'var(--nexus-archived-color)' : 'inherit')"
            [expanded]="true">
            <!-- <form [formGroup]="organisationFG" class="form-container"> -->
            <div style="padding: 6px; display: flex; flex-direction: column; gap: 10px">
                <fieldset
                    style="display: flex; flex-direction: column; gap: 10px; border-radius: var(--nexus-border-radius); ">
                    <legend>Denomination</legend>
                    <div style="display: flex; flex-direction: row; gap: 10px">
                        <mat-form-field appearance="outline" [style.width.px]="300" style="flex: 1 1 auto">
                            <mat-label>Name</mat-label>
                            <input matInput type="text" formControlName="name" />
                            @if (organisationFG.controls.name.invalid && organisationFG.controls.name.touched) {
                            <mat-error> Organisation name is required.</mat-error>
                            }
                            <mat-hint>
                                @if ((duplicateEntryResource.status() == 'resolved') &&
                                (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
                                ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
                                <span class="n-duplicate-warning">{{ duplicateEntryResource.value() |
                                    similarityList:'nameSimilarity':0.95:'name' }}</span>
                                }
                                @if (duplicateEntryResource.status() == 'error') {
                                <span class="n-duplicate-error">Error checking for similar entries</span>
                                }
                            </mat-hint>
                            <ng-container matSuffix>
                                @if (duplicateEntryResource.status() == 'loading') {
                                <div class="n-spinner-container">
                                    <mat-spinner diameter="32"></mat-spinner>
                                </div>
                                }
                            </ng-container>
                        </mat-form-field>
                        <mat-form-field appearance="outline" [style.width.px]="250">
                            <mat-label>Acronym</mat-label>
                            <input matInput type="text" formControlName="acronym" />
                            <mat-hint>
                                @if ((duplicateEntryResource.status() == 'resolved') &&
                                (((duplicateEntryResource.value()?.matchingItems ?? []).length > 0) ||
                                ((duplicateEntryResource.value()?.similarItems ?? []).length > 0))){
                                <span class="n-duplicate-warning">{{ duplicateEntryResource.value() |
                                    similarityList:'acronymSimilarity':0.95:'acronym' }}</span>
                                }
                                @if (duplicateEntryResource.status() == 'error') {
                                <span class="n-duplicate-error">Error checking for similar entries</span>
                                }
                            </mat-hint>
                        </mat-form-field>
                    </div>
                    <div style="display: flex; flex-direction: row; gap: 10px">
                        <mat-form-field appearance="outline" [style.width.px]="250">
                            <mat-label>Tax Id</mat-label>
                            <input matInput type="text" formControlName="taxId" />
                        </mat-form-field>
                        <mat-form-field appearance="outline" [style.width.px]="350" class="r-field r-inputfield">
                            <mat-label>Website</mat-label>
                            <mat-icon matPrefix>link</mat-icon>
                            <input matInput placeholder="Website" formControlName="website" appUrlNormalizer />
                            @if (organisationFG.get("website")?.hasError("invalidUrl")) {
                            <mat-error>Invalid URL</mat-error>
                            }
                        </mat-form-field>
                    </div>
                </fieldset>
                <fieldset
                    style="display: flex; flex-direction: column;  gap: 10px;  border-radius: var(--nexus-border-radius); ">
                    <legend>Postal addresses</legend>
                    <div formArrayName="addresses">
                        @for (address of addressesFA.controls;
                        track address;
                        let i = $index) {
                        <div style="display:flex; gap: 5px">
                            <app-postal-address [formGroup]="addressesFA.at(i)" [addressRequired]="false"
                                style="flex: 1 1 auto; display: flex; gap: 10px; border-radius: 5px" />
                            <div style="display: flex; margin-top:10px; flex: 0 0 0">
                                <button matMiniFab type="button" [class.n-delete-button]="(i>0)"
                                    matTooltip="Delete address" (click)="deleteAddress(i)" [disabled]="(i==0)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                        }
                    </div>
                    <button matMiniFab type="button" class="n-add-button" matTooltip="Add address"
                        (click)="addAddress()">
                        <mat-icon>add</mat-icon>
                    </button>
                </fieldset>
                <fieldset
                    style="display: flex; flex-direction: column;  gap: 10px;  border-radius: var(--nexus-border-radius); ">
                    <legend>Phone numbers</legend>
                    <div formArrayName="phoneNumbers" class="n-phone-grid">
                        @for (phone of phoneNumbersFA.controls;
                        track phone;
                        let i = $index) {
                        <div class="n-phone-item">
                            <app-phone-number [formGroup]="phoneNumbersFA.at(i)" [required]="true" />
                            <div style="display: flex; padding-top: 4px; flex: 0 0 0">
                                <button matMiniFab type="button" style="margin-top: 7px" class="n-delete-button"
                                    matTooltip="Delete phone number" (click)="deletePhoneNumber(i)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                        }
                    </div>
                    <button matMiniFab type="button" class="n-add-button" matTooltip="Add phone number"
                        (click)="addPhoneNumber()">
                        <mat-icon>add</mat-icon>
                    </button>
                </fieldset>

                <fieldset
                    style=" display: flex; flex-direction: column;  align-items:baseline; gap: 15px;  border-radius: var(--nexus-border-radius); padding-top: 15px;">
                    <legend>Involvement with EUFIC</legend>
                    <mat-form-field appearance="outline" class="n-full-width-field">
                        <mat-label>Stakeholder groups
                            @if (organisationFG.controls.stakeholderGroups.hasValidator(Validators.required)) {
                            *
                            }
                        </mat-label>
                        <app-advanced-chip-select #stakeholderGroupsSelect placeholder="Add group..."
                            formControlName="stakeholderGroups" [allOptions]="allStakeholderGroupOptions()" />
                        <mat-hint>Add all that apply</mat-hint>
                        @if (organisationFG.controls.stakeholderGroups.hasError('required') &&
                        organisationFG.controls.stakeholderGroups.touched) {
                        <mat-error>Select at least one group</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="n-full-width-field">
                        <mat-label>Topics of interest</mat-label>
                        <app-advanced-chip-select #topicsSelect placeholder="Add topic..." formControlName="topics"
                            [allOptions]="allGeneralTopicOptions()" />
                        <mat-hint>Add only the topics that you are sure the organisation is interested in</mat-hint>
                        @if (organisationFG.controls.topics.hasError('required')) {
                        <mat-error>Select at least one topic</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="n-full-width-field">
                        <mat-label>Projects with EUFIC</mat-label>
                        <app-advanced-chip-select #projectsSelect placeholder="Add project..."
                            formControlName="projects" [allOptions]="allProjectOptions()" />
                        <mat-hint>You can add new projects from the <i>projects</i> screen</mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="n-full-width-field">
                        <mat-label>Initiatives</mat-label>
                        <app-advanced-chip-select #initiativesSelect placeholder="Add initiative..."
                            formControlName="initiatives" [allOptions]="allInitiativeOptions()"
                            (addOption)="onAddInitiative($event)" [_allowNewItem]="true" />
                        <mat-hint>To add an initiative, type its name and press enter</mat-hint>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="n-full-width-field">
                        <mat-label>Target audiences</mat-label>
                        <app-advanced-chip-select #audiencesSelect placeholder="Add audience..."
                            formControlName="targetAudiences" [allOptions]="allAudienceOptions()" />
                        <mat-hint>See examples of target audiences <a target="_blank"
                                href="https://eufic.slite.com/api/s/D6jQtMuQjUpbtq/EUFIC-s-stakeholders-and-target-audiences">here</a>
                        </mat-hint>

                    </mat-form-field>
                </fieldset>

                <!-- <fieldset
                    style=" display: flex; flex-direction: column;  align-items:baseline; gap: 15px;  border-radius: var(--nexus-border-radius); padding-top: 15px;">
                    <legend>Interest</legend>
                    @if (authService.isRegularUser) {
                    <div style="color: var(--nexus-warm-orange ); font-style:italic"><i class="fa-solid fa-ban"></i> You
                        do not have permission to edit membership data
                    </div>
                    }
                    <div>
                        <mat-checkbox formControlName="membershipInterest" appAdvancedUsersOnly>Interested in
                            membership</mat-checkbox>
                    </div>
                </fieldset> -->
                <mat-form-field appearance="outline" hintLabel="Max {{ additionalInfoMaxLen }} characters"
                    style="margin-top: 10px">
                    <mat-label>Additional information</mat-label>
                    <textarea matInput formControlName="additionalInfo" rows="5" cols="100"></textarea>
                    <mat-hint align="end">{{ organisationFG.controls.additionalInfo.value?.length || 0 }}/{{
                        additionalInfoMaxLen
                        }}
                    </mat-hint>
                </mat-form-field>
            </div>

        </mat-expansion-panel>

        <mat-expansion-panel class="n-membership-data-panel"
            [style.background-color]="(organisation.archived ? 'var(--nexus-archived-color)' : 'inherit')"
            [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title style="display: flex; align-items: baseline; justify-content: space-between">
                    <div style="display: flex; align-items: center; gap: 10px;">
                        <!-- <mat-checkbox matTooltip="Select if this organisation is also a member" matTooltipPosition="above"
                    formControlName='isMemberCheckbox' (click)="$event.stopPropagation();"
                    (change)="toggleMember($event)">
                </mat-checkbox> -->
                        @if (isCurrentMember) {
                        <span class="material-symbols-outlined" style="color: var(--nexus-fir)"
                            matTooltip="The organisation is an active member">family_star</span>
                        }
                        <span>Membership details</span>
                    </div>
                    @if (authService.isRegularUser) {
                    <div style="color: var(--nexus-warm-orange ); font-style:italic"><i class="fa-solid fa-ban"></i> You
                        do not have permission to edit membership data
                    </div>
                    }
                    <div style="font-style:italic">
                        Fill in this section only if the organisation is also a member.
                    </div>
                </mat-panel-title>
            </mat-expansion-panel-header>

            @if (activeMembershipTab() === 0) {
            <mat-action-row class="row">
                <div class="left">
                    <button matMiniFab type="button" class="n-add-button" matTooltip="Add membership record"
                        (click)="addMembershipRecord()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
                <div class="center">
                    @if (membershipRecordsFA.errors?.['overlappingPeriods']) {
                    <mat-error>There are overlapping membership records</mat-error>
                    }
                </div>
                <div class="right"></div>
            </mat-action-row>
            }

            <mat-tab-group style="margin-left: 5px; margin-right: 5px;"
                (selectedIndexChange)="activeMembershipTab.set($event)">
                <mat-tab label="Active and future membership details">
                    <div formArrayName="membershipRecords">
                        @for (mrFormGroup of membershipRecordsFA.controls; track mrFormGroup; let i = $index) {
                        <div [formGroupName]="i" class="n-membership-record-container"
                            [style.background-color]="(organisation.archived ? 'var(--nexus-archived-color)' : 'inherit')">
                            <div style="display: flex; flex-direction: column; padding: 10px; gap: 10px">
                                <fieldset
                                    style=" display: flex; flex-direction: column; gap: 10px; border-radius: var(--nexus-border-radius); ">
                                    <legend>Administrative data</legend>
                                    <div>
                                        <div style="display: flex; gap: 10px; align-items: baseline;">
                                            <mat-form-field appearance="outline" class="n-contract-start-date-field">
                                                <mat-label>Contract start date</mat-label>
                                                <input matInput [matDatepicker]="startPicker"
                                                    formControlName="contractStartDate">
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="startPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #startPicker></mat-datepicker>
                                                @if (mrFormGroup.get('contractStartDate')?.invalid) {
                                                <mat-error> Contract start date is required.</mat-error>
                                                }
                                            </mat-form-field>
                                            <mat-form-field appearance="outline" class="n-contract-end-date-field">
                                                <mat-label>Contract end date</mat-label>
                                                <input matInput [matDatepicker]="endPicker"
                                                    formControlName="contractEndDate">
                                                <mat-datepicker-toggle matSuffix
                                                    [for]="endPicker"></mat-datepicker-toggle>
                                                <mat-datepicker #endPicker></mat-datepicker>
                                                @if (mrFormGroup.get('contractEndDate')?.hasError('matDatepickerParse'))
                                                {
                                                <mat-error> Contract end date is invalid.</mat-error>
                                                }
                                                @if
                                                (mrFormGroup.get('contractEndDate')?.hasError('invalidDateRange'))
                                                {
                                                <mat-error> Contract can't end before its start.</mat-error>
                                                }
                                            </mat-form-field>
                                            @if (isPastDate(mrFormGroup.get('contractEndDate')!.value)) {
                                            <div class="n-flex-row-left">
                                                <span class="material-symbols-outlined"
                                                    style="color: var(--nexus-warm-orange)"
                                                    matTooltip="Setting the end date in the past will make the record unmodifiable.">warning</span>
                                                <span class="n-warning-message"> You are creating a past membership
                                                    record.</span>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <div>
                                        <label>This is a trial membership</label>
                                        <mat-checkbox formControlName="trialMember"
                                            matTooltip="Select if this is a trial membership"
                                            matTooltipPosition="above">
                                        </mat-checkbox>
                                    </div>
                                    <div>
                                        <label>Member type</label>
                                        <mat-radio-group formControlName="memberType" aria-label="Member type">
                                            <mat-radio-button
                                                [value]="MemberType.ASSOCIATE">Associate</mat-radio-button>
                                            <mat-radio-button [value]="MemberType.FULL">Full</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                    <div>
                                        <label>Engagement level</label>
                                        <mat-radio-group formControlName="engagementLevel">
                                            <mat-radio-button [value]="null">Unknown</mat-radio-button>
                                            <mat-radio-button [value]="ThreeLevelScale.LOW">Low</mat-radio-button>
                                            <mat-radio-button [value]="ThreeLevelScale.MEDIUM">Medium</mat-radio-button>
                                            <mat-radio-button [value]="ThreeLevelScale.HIGH">High</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                    <div>
                                        <app-searchable-select class="n-language-field" appearance="outline"
                                            hint="To add a new language, type it and press enter (English is default)"
                                            formControlName="language" label="Language" itemName="language"
                                            [options]="allLanguageOptions()" prefixIcon="language"
                                            (addOption)="onAddLanguage(i, $event)" [allowNewItem]="true" />
                                    </div>
                                </fieldset>
                                <fieldset
                                    style=" display: flex; flex-direction: row; gap: 10px; border-radius: var(--nexus-border-radius); ">
                                    <legend>Contact data</legend>
                                    <app-searchable-select class="n-primary-contact-field" appearance="outline"
                                        formControlName="primaryContact" label="Primary contact"
                                        itemName="primaryContact" [options]="allContactOptions()"
                                        prefixIcon="account_circle" [allowNewItem]="false" [showLink]="true"
                                        linkItem="contact" />
                                    <app-searchable-select class="n-invoicing-contact-field" appearance="outline"
                                        formControlName="invoicingContact" label="Invoicing contact"
                                        itemName="invoicingContact" [options]="allContactOptions()" prefixIcon="receipt"
                                        [allowNewItem]="false" [showLink]="true" linkItem="contact" />
                                    <app-searchable-select class="n-contract-contact-field" appearance="outline"
                                        formControlName="contractContact" label="Contract contact"
                                        itemName="contractContact" [options]="allContactOptions()"
                                        prefixIcon="card_travel" [allowNewItem]="false" [showLink]="true"
                                        linkItem="contact" />

                                </fieldset>
                                <fieldset
                                    style=" display: flex; flex-direction: column;  align-items:baseline; gap: 15px;  border-radius: var(--nexus-border-radius); padding-top: 15px;">
                                    <legend>Involvement with EUFIC</legend>
                                    <mat-form-field appearance="outline" class="n-full-width-field">
                                        <mat-label>Topics of interest</mat-label>
                                        <app-advanced-chip-select #memberTopicsSelect placeholder="Add topic..."
                                            formControlName="topics" [allOptions]="allMemberTopicOptions()" />
                                    </mat-form-field>
                                </fieldset>

                                <mat-form-field appearance="outline"
                                    hintLabel="Max {{ additionalInfoMaxLen }} characters" style="margin-top: 10px">
                                    <label>Notes</label>
                                    <textarea matInput formControlName="notes" rows="5" cols="100"></textarea>
                                    <mat-hint align="end">{{ mrFormGroup.get("notes")?.value?.length || 0 }}/{{
                                        additionalInfoMaxLen
                                        }}
                                    </mat-hint>
                                </mat-form-field>
                            </div>

                        </div>
                        <button matButton="elevated" class="n-delete-button" (click)="deleteMembershipRecord(i)"
                            style="margin: 10px 0px 5px 0px;">
                            <mat-icon>delete</mat-icon> Delete membership record
                        </button>
                        }
                    </div>
                </mat-tab>
                <mat-tab label="Past membership details ({{ pastMembershipRecords.length}})">
                    @for (pmr of pastMembershipRecords; track pmr) {
                    <mat-card class="pmr-details-card">
                        <mat-card-header>{{ pmr.contractPeriodDisplay }}</mat-card-header>
                        <mat-card-content>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Membership type</span>
                                <span class="mr-field-value">{{pmr.membershipTypeDisplay}}</span>
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Member type</span>
                                <span class="mr-field-value">{{pmr.memberTypeDisplay}}</span>
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Engagement level</span>
                                <span class="mr-field-value">{{pmr.engagementLevelDisplay}}</span>
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Language</span>
                                <span class="mr-field-value">{{pmr.language?.name}}</span>
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Primary contact</span>
                                <span class="mr-field-value">{{pmr.primaryContact? pmr.primaryContact.fullName :
                                    ''}}</span>
                                @if (pmr.primaryContact?.id) {
                                <a [attr.href]=" pmr.primaryContact!.id  | urlMaker : 'contact'" target="_blank">
                                    <span matSuffix
                                        class="material-symbols-outlined n-small-link-icon">open_in_new</span></a>
                                }
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Invoicing contact</span>
                                <span class="mr-field-value">{{pmr.invoicingContact? pmr.invoicingContact.fullName :
                                    ''}}</span>
                                @if (pmr.invoicingContact?.id) {
                                <a [attr.href]=" pmr.invoicingContact!.id  | urlMaker : 'contact'" target="_blank">
                                    <span matSuffix
                                        class="material-symbols-outlined n-small-link-icon">open_in_new</span></a>
                                }
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Contract contact</span>
                                <span class="mr-field-value">{{pmr.contractContact? pmr.contractContact.fullName :
                                    ''}}</span>
                                @if (pmr.contractContact?.id) {
                                <a [attr.href]=" pmr.contractContact!.id  | urlMaker : 'contact'" target="_blank">
                                    <span matSuffix
                                        class="material-symbols-outlined n-small-link-icon">open_in_new</span></a>
                                }
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Topics of interest</span>
                                <span class="mr-field-value">{{pmr.memberTopicsDisplay}}</span>
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Notes</span>
                                <span class="mr-field-value">{{pmr.notes}}</span>
                            </div>
                            <div matListItemLine class="mr-field-row">
                                <span class="mr-field-name">Last update</span>
                                <span class="mr-field-value">{{pmr | lastUpdate}}</span>
                            </div>
                        </mat-card-content>
                    </mat-card>
                    }
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>

        <mat-expansion-panel class="n-supplier-data-panel"
            [style.background-color]="(organisation.archived ? 'var(--nexus-archived-color)' : (isSupplier() ? 'var(--nexus-supplier-data-bgcolor)' : 'inherit'))"
            [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <mat-checkbox matTooltip="Select if the organisation is also a supplier" matTooltipPosition="above"
                        [checked]="isSupplier()" (click)="$event.stopPropagation();" (change)="toggleSupplier($event)">
                    </mat-checkbox>
                    <span>Supplier details</span>
                </mat-panel-title>
                <div style="padding: 0px 15px 10px 15px; font-style:italic">
                    Fill in this section only if the organisation is also a supplier.
                </div>
            </mat-expansion-panel-header>

            <div [formGroup]="supplierDetailsFG" class="form-container">
                <div style="display: flex; flex-direction: column; padding: 10px; gap: 10px">
                    <fieldset
                        style="display: flex; flex-direction: column; gap: 10px; border-radius: var(--nexus-border-radius); margin-top: 10px;">
                        <legend>Products</legend>
                        <mat-form-field appearance="outline" class="long-field">
                            <mat-label>Products</mat-label>
                            <app-advanced-chip-select #productsSelect placeholder="Add product..." required
                                formControlName="products" [allOptions]="allProductOptions()" />
                            <mat-error>At least one product must be selected</mat-error>
                        </mat-form-field>
                    </fieldset>
                    <mat-form-field appearance="outline" hintLabel="Max {{ additionalInfoMaxLen }} characters"
                        style="margin-top: 10px">
                        <mat-label>Additional information</mat-label>
                        <textarea matInput formControlName="additionalInfo" rows="5" cols="100"></textarea>
                        <mat-hint align="end">{{ supplierDetailsFG.controls.additionalInfo.value?.length || 0 }}/{{
                            additionalInfoMaxLen
                            }}
                        </mat-hint>
                    </mat-form-field>
                    <fieldset
                        style=" display: flex; flex-direction: row; flex-wrap: wrap; gap: 10px; border-radius: var(--nexus-border-radius); ">
                        <legend>Administrative data</legend>
                        <mat-form-field appearance="outline" class="n-half-width r-field r-inputfield">
                            <mat-label>Website</mat-label>
                            <mat-icon matPrefix>link</mat-icon>
                            <input matInput size="40" placeholder="Website" formControlName="website"
                                appUrlNormalizer />
                            @if (supplierDetailsFG.controls.website.hasError("invalidUrl")) {
                            <mat-error>Invalid URL</mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline" class="n-half-width r-field r-inputfield">
                            <mat-label>Email</mat-label>
                            <mat-icon matPrefix>email</mat-icon>
                            <input matInput size="40" placeholder="Email" formControlName="supplierEmail" />
                            @if (supplierDetailsFG.controls.supplierEmail.hasError("invalidEmail")) {
                            <mat-error>Invalid email</mat-error>
                            }
                        </mat-form-field>
                        <!-- <mat-form-field appearance="outline" class="n-half-width r-field r-inputfield">
                        <mat-label>Drive folder</mat-label>
                        <input matInput placeholder="Drive folder" formControlName="driveFolder" />
                        <mat-icon matPrefix>folder</mat-icon>
                        <mat-hint>Add path to S drive folder where contracts/quotations are stored
                        </mat-hint>
                    </mat-form-field> -->
                        <!-- <div class="n-half-width">
                    </div> -->
                        <div class="n-half-width">
                            <label>Did we work with them?</label>
                            <mat-radio-group formControlName="ongoingRelationship">
                                <mat-radio-button [value]="OngoingRelationship.YES">Yes</mat-radio-button>
                                <mat-radio-button [value]="OngoingRelationship.QUOTATION_ONLY">Quotation
                                    only
                                </mat-radio-button>
                                <mat-radio-button [value]="OngoingRelationship.NOT_YET">Not yet</mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <!-- <div class="n-half-width">
                        <label>Feedback</label>
                        <mat-radio-group formControlName="supplierFeedback">
                            <mat-radio-button [value]="SupplierFeedback.GOOD">Good</mat-radio-button>
                            <mat-radio-button [value]="SupplierFeedback.AVERAGE">Average</mat-radio-button>
                            <mat-radio-button [value]="SupplierFeedback.AVOID">Avoid</mat-radio-button>
                            <mat-radio-button [value]="SupplierFeedback.NOT_YET">Not sure</mat-radio-button>
                        </mat-radio-group>
                    </div> -->
                    </fieldset>


                </div>
            </div>
        </mat-expansion-panel>

        @if (organisation.id) {
        <app-history-panel entityType="organisation" [entityId]="organisation.id"></app-history-panel>
        }

        <div class="n-button-row">
            <button matFab extended class="n-cancel-button" (click)="cancel()">
                <mat-icon>cancel</mat-icon>
                Cancel
            </button>
            <button matFab extended class="n-save-button" (click)="save()">
                <mat-icon>save</mat-icon>
                {{ mode === "Create" ? "Save" : "Update" }}
            </button>
            @if (mode === "Update") {
            <button matFab extended class="n-archive-button" (click)="toggleArchive()">
                <mat-icon>{{organisation.archived ? 'unarchive' : 'archive'}}</mat-icon>
                {{organisation.archived ? 'Un-archive' : 'Archive'}}
            </button>
            <button matFab extended class="n-delete-button" [disabled]="!authService.isAdmin" (click)="delete()">
                <mat-icon>delete</mat-icon>
                Delete
            </button>
            }
        </div>

    </mat-accordion>
</form>